import Button from "../Button/Button.component";
import styles from "./Header.module.scss";
import React, { useEffect, useState } from "react";
import logo from "../../assets/flare-space-logo.svg";
import { FLARE_SPACE_DOMAIN } from "../../constants";
import Footer from "../Footer/Footer.component";
import TimeZoneSelect from "../timeZoneSelect/TimeZoneSelect";

const Header: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  useEffect(() => {
    document.addEventListener("toggle-menu-event", ((event: CustomEvent) => {
      console.log("event fired", event.detail);
      if (event.detail === "open") {
        setOpen(true);
      } else if (event.detail === "close") {
        setOpen(false);
      }
    }) as EventListener);
  }, []);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.background}></div>
        <nav>
          <Button href={FLARE_SPACE_DOMAIN} noStyles={true}>
            <img className={styles.logo} src={logo} alt="flare.space" />
          </Button>
          <aside>
            <flare-space-menu>
               <TimeZoneSelect />
              {/*<div className={styles.connectButton}>Connect Wallet</div>*/}
              <div slot="mobile-footer">
                <Footer mobile={true} />
              </div>
            </flare-space-menu>
          </aside>
        </nav>
      </div>
    </>
  );
};

export default Header;
